<template>
  <section>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(save_performance_activity)">
        <div class="modal-card" style="width: 1000px">
          <header class="modal-card-head">
            <p class="modal-card-title">Declarar Horas Realizadas</p>
            <button type="button" class="delete" @click="$emit('close')" />
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <b-field label="Actividad Académica">
                  <b-input
                    v-model="performanceActivity.activity_name"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
              <div v-if="asignatura" class="column">
                <b-field label="Asignatura">
                  <b-input
                    v-model="asignatura.codigo_nombre"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Tipo de horas">
                  <b-input v-model="tipo_hora" disabled="true"></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Horas comprometidas 1er semestre">
                  <b-input
                    v-model="performanceActivity.hours_committed_semester_1"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Horas comprometidas 2do semestre">
                  <b-input
                    v-model="performanceActivity.hours_committed_semester_2"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Horas realizadas 1er semestre*">
                  <validation-provider
                    rules="required|numeric|min_value:0"
                    v-slot="{ errors }"
                  >
                  <b-input
                    v-model="performanceActivity.hours_completed_semester_1"
                    :disabled="isFromSAI"
                  ></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </validation-provider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Horas realizadas 2do semestre*">
                  <validation-provider
                    rules="required|numeric|min_value:0"
                    v-slot="{ errors }"
                  >
                  <b-input
                    v-model="performanceActivity.hours_completed_semester_2"
                    :disabled="isFromSAI"
                  ></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </validation-provider>
                </b-field>
              </div>
              <div v-if="asignatura" class="column is-narrow">
                <br />
                <b-field label=" ">
                  <b-button
                    type="is-primary"
                    icon-left="plus"
                    @click="openModalSaiHours"
                  >
                    Completar Horas con SAI
                  </b-button>
                </b-field>
              </div>
            </div>
            <!-- Mensaje informativo cuando las horas vienen de SAI -->
            <div v-if="isFromSAI" class="columns">
              <div class="column">
                <b-message type="is-info" has-icon>
                  <strong>Horas obtenidas desde SAI:</strong> Las horas fueron completadas automáticamente desde el Sistema Académico Integrado y no pueden ser modificadas manualmente. 
                  <span v-if="performanceActivity.subject_code">Código de asignatura: <strong>{{ performanceActivity.subject_code }}</strong></span>
                  <br><br>
                  <strong>Nota:</strong> No es necesario subir evidencias para actividades con horas obtenidas desde SAI.
                </b-message>
              </div>
            </div>

            <!-- Mensaje de advertencia cuando se requieren evidencias -->
            <div v-if="requiresEvidence" class="columns">
              <div class="column">
                <b-message type="is-warning" has-icon>
                  <strong>⚠️ Atención:</strong> Usted está evidenciando más horas de las comprometidas por lo que es obligatorio subir evidencias.
                </b-message>
              </div>
            </div>

            <!-- Sección de Evidencias -->
            <div v-if="!shouldDisableEvidences" class="columns">
              <div class="column">
                <!-- Checkbox para evidencias opcionales (cuando no son obligatorias) -->
                <div v-if="!requiresEvidence && !isFromSAI" class="field mb-4">
                  <b-checkbox 
                    v-model="enableEvidenceUpload" 
                    size="is-small"
                  >
                    <span class="icon">
                      <i class="fas fa-paperclip"></i>
                    </span>
                    <span class="ml-1">
                      Subir evidencias
                      <span class="tag is-info ml-2">Opcional</span>
                    </span>
                  </b-checkbox>
                </div>

                <!-- Collapse para evidencias (visible cuando son obligatorias o cuando se marca el checkbox) -->
                <b-collapse
                  v-if="requiresEvidence || enableEvidenceUpload || existingEvidences.length > 0"
                  class="card"
                  animation="slide"
                  :open="true"
                >
                  <template #trigger="props">
                    <div
                      class="card-header"
                      role="button"
                      style="cursor: pointer;"
                    >
                      <p class="card-header-title">
                        <span class="icon">
                          <i class="fas fa-paperclip"></i>
                        </span>
                        <span class="ml-2">
                          Evidencias
                          <span v-if="existingEvidences.length > 0 || (files && files.length > 0)" class="tag is-info ml-2">
                            {{ (existingEvidences.length || 0) + (files ? files.length : 0) }}
                          </span>
                          <span v-if="requiresEvidence" class="tag is-danger ml-2">Obligatorio</span>
                          <span v-else class="tag is-info ml-2">Opcional</span>
                        </span>
                      </p>
                      <a class="card-header-icon">
                        <b-icon :icon="props.open ? 'angle-up' : 'angle-down'"></b-icon>
                      </a>
                    </div>
                  </template>

                  <div class="card-content">
                    <!-- Evidencias ya subidas -->
                    <div v-if="existingEvidences.length > 0">
                      <b-field label="Evidencias Subidas">
                        <div class="box">
                          <b-table
                            :data="existingEvidences"
                            :mobile-cards="false"
                            :narrowed="true"
                          >
                            <b-table-column
                              field="icon"
                              label=""
                              width="40"
                              v-slot="{ row }"
                            >
                              <b-icon
                                :icon="getFileIcon(row.alt_name)"
                                :type="getFileIconColor(row.alt_name)"
                              />
                            </b-table-column>

                            <b-table-column
                              field="alt_name"
                              label="Archivo"
                              v-slot="{ row }"
                            >
                              {{ row.alt_name }}
                            </b-table-column>

                            <b-table-column
                              field="created_at"
                              label="Fecha"
                              v-slot="{ row }"
                            >
                              {{ formatDate(row.created_at) }}
                            </b-table-column>

                            <b-table-column
                              field="actions"
                              label="Acciones"
                              width="120"
                              v-slot="{ row }"
                            >
                              <div class="buttons is-centered">
                                <b-button
                                  type="is-info"
                                  icon-left="eye"
                                  size="is-small"
                                  @click="viewEvidence(row)"
                                  title="Ver archivo"
                                />
                                <b-button
                                  type="is-danger"
                                  icon-left="trash-alt"
                                  size="is-small"
                                  @click="confirmDeleteEvidence(row)"
                                  title="Eliminar archivo"
                                />
                              </div>
                            </b-table-column>
                          </b-table>
                        </div>
                      </b-field>

                      <!-- Separador -->
                      <hr class="my-4">
                    </div>

                    <!-- Área para agregar nuevas evidencias -->
                    <div class="has-text-centered">
                      <p class="has-text-weight-semibold mb-3">
                        {{ existingEvidences.length > 0 ? 'Agregar Más Evidencias' : 'Agregar Evidencias' }}
                        (Word, Excel, PDF, JPEG y PNG)
                      </p>
                      <div class="upload-container-centered">
                        <b-upload
                          v-model="files"
                          drag-drop
                          multiple
                          type="is-primary"
                          accept=".docx,.pdf,.doc,.xlsx,.png,.jpeg"
                          class="compact-upload"
                        >
                          <div class="compact-drop-area">
                            <b-icon icon="upload" size="is-medium"></b-icon>
                            <span class="ml-2">Arrastra tu archivo o haz click aquí.</span>
                          </div>
                        </b-upload>
                      </div>
                      <div class="tags mt-2 is-centered is-justify-content-center" v-if="files && files.length > 0">
                        <span
                          v-for="(file, index) in files"
                          :key="index"
                          class="tag is-primary"
                        >
                          {{ file.name }}
                          <button
                            class="delete is-small"
                            type="button"
                            @click="deleteDropFile(index)"
                          ></button>
                        </span>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>

            <!-- ELIMINAR: Área de carga cuando NO hay evidencias existentes -->
            <div v-if="false" class="columns has-text-centered">
              <div class="column">
                <b-field
                  extended
                  label="Agregar Nuevas Evidencias (Word, Excel, PDF, JPEG y PNG)"
                >
                  <b-upload
                    v-model="files"
                    drag-drop
                    multiple
                    type="is-primary"
                    accept=".docx,.pdf,.doc,.xlsx,.png,.jpeg"
                  >
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Arrastra tu archivo o haz click aquí.</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
                <div class="tags">
                  <span
                    v-for="(file, index) in files"
                    :key="index"
                    class="tag is-primary"
                  >
                    {{ file.name }}
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteDropFile(index)"
                    ></button>
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button class="button" type="button" @click="$emit('close')">
              Cerrar
            </button>
            <button class="button is-primary" type="submit">Actualizar</button>
          </div>
        </footer>
      </form>
    </ValidationObserver>
    <b-modal
      :active.sync="isActiveModalSaiHours"
      :width="800"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      aria-label="Modal para completar horas con SAI"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Horas Realizadas</p>
        </header>
        <div class="card-content">
          <b-table
            paginated
            per-page="10"
            :pagination-simple="false"
            pagination-position="bottom"
            aria-next-label="Siguiente"
            aria-previous-label="Anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
            :data="filteredSubjects"
          >
            <b-table-column field="codigo" label="Código" v-slot="props">
              {{ props.row.codigo }}
            </b-table-column>
            <b-table-column
              field="asignatura"
              label="Asignatura"
              v-slot="props"
            >
              {{ props.row.asignatura }}
            </b-table-column>

            <b-table-column field="semestre" label="Semestre" v-slot="props">
              {{ props.row.semestre }}
            </b-table-column>
            <b-table-column field="horario" label="Horario" v-slot="props">
              {{ props.row.horario }}
            </b-table-column>
            <b-table-column field="tel" label="TEL" v-slot="props">
              {{ props.row.tel }}
            </b-table-column>
            <b-table-column
              field="total_hours"
              label="Horas Totales"
              v-slot="props"
            >
              {{ props.row.total_hours }}
            </b-table-column>
          </b-table>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button
              class="button"
              type="button"
              @click="isActiveModalSaiHours = false"
            >
              Cerrar
            </button>
            <button
              class="button is-primary"
              type="button"
              @click="completeHoursWithSai"
            >
              Completar horas
            </button>
          </div>
        </footer>
      </div>
    </b-modal>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "modalAddHours",
  props: {
    activityId: {
      type: Number,
      required: true,
    },
    subjects: {
      type: Array,
      required: true,
    },
    subjectsSemester1: {
      type: Array,
      required: true,
    },
    subjectsSemester2: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      performanceActivity: {
        activity_name: "",
      },
      isLoading: false,
      tipo_hora: "Semanales",
      files: null,
      asignatura: null,
      isActiveModalSaiHours: false,
      filteredSubjects: [],
      totalHoursSemester1: 0,
      totalHoursSemester2: 0,
      existingEvidences: [], // Evidencias ya subidas
      saiAutoFetchAttempted: false, // Flag para saber si ya se intentó cargar SAI automáticamente
      saiAutoFetchSuccess: false, // Flag para saber si la carga automática fue exitosa
      enableEvidenceUpload: false, // Flag para habilitar subida opcional de evidencias
    };
  },
  computed: {
    // Verifica si las horas fueron completadas con SAI (no editables)
    // Solo es verdadero si tiene subject_code Y la carga automática fue exitosa O ya tenía horas completadas previamente
    isFromSAI() {
      return (this.performanceActivity.subject_code != null && 
              this.performanceActivity.subject_code !== '' && 
              (this.saiAutoFetchSuccess || this.performanceActivity.sai_hours_source === true));
    },
    // Verifica si se deben deshabilitar las evidencias (cuando hay datos SAI exitosos)
    shouldDisableEvidences() {
      return this.isFromSAI;
    },
    // Verifica si las horas realizadas exceden las comprometidas
    requiresEvidence() {
      // Si las horas vienen de SAI exitosamente, NO requiere evidencias
      if (this.isFromSAI) {
        return false;
      }

      const completedSem1 = parseFloat(this.performanceActivity.hours_completed_semester_1) || 0;
      const committedSem1 = parseFloat(this.performanceActivity.hours_committed_semester_1) || 0;
      const completedSem2 = parseFloat(this.performanceActivity.hours_completed_semester_2) || 0;
      const committedSem2 = parseFloat(this.performanceActivity.hours_committed_semester_2) || 0;
      
      return completedSem1 > committedSem1 || completedSem2 > committedSem2;
    },
    // Verifica si hay evidencias subidas (existentes o nuevas)
    hasEvidences() {
      return (this.existingEvidences && this.existingEvidences.length > 0) || 
             (this.files && this.files.length > 0);
    }
  },
  watch: {
    // Limpiar subject_code si el usuario modifica manualmente las horas después de haberlas completado con SAI
    'performanceActivity.hours_completed_semester_1': function(newVal, oldVal) {
      // Solo limpiar si había un subject_code previo y el cambio no viene de completeHoursWithSai
      if (this.performanceActivity.subject_code && oldVal !== undefined && oldVal !== null && oldVal !== '') {
        // Verificar que el cambio es manual (no viene de totalHoursSemester1)
        if (newVal != this.totalHoursSemester1) {
          this.performanceActivity.subject_code = null;
          this.$buefy.toast.open({
            message: "Las horas fueron modificadas manualmente. Ya no se considerarán como datos de SAI.",
            type: "is-warning",
            duration: 4000
          });
        }
      }
    },
    'performanceActivity.hours_completed_semester_2': function(newVal, oldVal) {
      // Solo limpiar si había un subject_code previo y el cambio no viene de completeHoursWithSai
      if (this.performanceActivity.subject_code && oldVal !== undefined && oldVal !== null && oldVal !== '') {
        // Verificar que el cambio es manual (no viene de totalHoursSemester2)
        if (newVal != this.totalHoursSemester2) {
          this.performanceActivity.subject_code = null;
          this.$buefy.toast.open({
            message: "Las horas fueron modificadas manualmente. Ya no se considerarán como datos de SAI.",
            type: "is-warning",
            duration: 4000
          });
        }
      }
    }
  },
  created() {
    this.get_performance_activity();
  },
  methods: {
    get_performance_activity() {
      this.isLoading = true;
      axios
        .get(`/activity_performances/${this.activityId}.json`)
        .then((response) => {
          this.performanceActivity = response.data;
          if (this.performanceActivity.is_weekly_hours) {
            this.tipo_hora = "Semanales";
          } else {
            this.tipo_hora = "Semestrales";
          }
          if (
            this.performanceActivity.subject_code === null ||
            this.performanceActivity.subject_code === undefined
          ) {
            this.asignatura = null;
          } else {
            this.asignatura = this.subjects.find(
              (subject) =>
                subject.codigo ===
                parseInt(this.performanceActivity.subject_code)
            );
          }
          
          // Cargar evidencias existentes (filtrar evidencias SAI)
          this.existingEvidences = (this.performanceActivity.evidences || []).filter(
            evidence => evidence.id !== -1 // Excluir evidencias SAI
          );
          
          // Resetear flag de evidencias opcionales al cargar
          this.enableEvidenceUpload = false;
          
          this.isLoading = false;
          
          // DESPUÉS de cargar todo, intentar obtener horas automáticamente desde SAI
          this.$nextTick(() => {
            this.attemptAutoFetchFromSAI();
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    deleteDropFile(index) {
      this.files.splice(index, 1);
    },
    save_performance_activity() {
      // Validar que haya evidencias si son obligatorias
      if (this.requiresEvidence && !this.hasEvidences) {
        this.$buefy.dialog.alert({
          title: 'Evidencias Obligatorias',
          message: 'Debe subir al menos una evidencia ya que las horas realizadas exceden las horas comprometidas.',
          type: 'is-warning',
          hasIcon: true,
          icon: 'alert-circle-outline',
          iconPack: 'mdi',
          confirmText: 'Entendido'
        });
        return;
      }

      // Validar si las horas declaradas son 0 en ambos semestres
      const hours1 = parseFloat(this.performanceActivity.hours_completed_semester_1) || 0;
      const hours2 = parseFloat(this.performanceActivity.hours_completed_semester_2) || 0;
      
      if (hours1 === 0 && hours2 === 0) {
        this.$buefy.dialog.confirm({
          title: 'Actividad sin Horas Declaradas',
          message: `<div style="text-align: left;">
                      <p><strong>⚠️ Advertencia:</strong> Está declarando <strong>0 horas realizadas</strong> para la siguiente actividad:</p>
                      <div class="box mt-3 mb-3" style="background-color: #fff3cd; border-left: 4px solid #ffb300;">
                        <p class="has-text-weight-bold">${this.performanceActivity.activity_name}</p>
                        <p class="mt-2" style="font-size: 0.9em;">
                          <strong>Horas comprometidas:</strong> 
                          ${this.performanceActivity.hours_committed_semester_1}h (1er sem) + 
                          ${this.performanceActivity.hours_committed_semester_2}h (2do sem)
                        </p>
                      </div>
                      <p>¿Está seguro de que desea continuar sin declarar horas para esta actividad?</p>
                      <p class="mt-2" style="font-size: 0.9em; color: #666;">
                        Si no realizó esta actividad, puede confirmar con 0 horas.
                      </p>
                    </div>`,
          confirmText: 'Sí, confirmar 0 horas',
          cancelText: 'No, volver a editar',
          type: 'is-warning',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi',
          onConfirm: () => {
            this.submitPerformanceActivity();
          }
        });
        return;
      }

      // Si todo está bien, enviar directamente
      this.submitPerformanceActivity();
    },

    submitPerformanceActivity() {
      let formData = new FormData();
      formData.append(
        "hours_completed_semester_1",
        this.performanceActivity.hours_completed_semester_1
      );
      formData.append(
        "hours_completed_semester_2",
        this.performanceActivity.hours_completed_semester_2
      );
      
      // Enviar subject_code si existe (indica que viene de SAI)
      if (this.performanceActivity.subject_code) {
        formData.append("subject_code", this.performanceActivity.subject_code);
      } else {
        // Si no tiene subject_code, enviar vacío para limpiarlo en BD
        formData.append("subject_code", "");
      }
      
      // Enviar flag que indica si las horas vienen automáticamente de SAI
      formData.append("sai_hours_source", this.saiAutoFetchSuccess ? "true" : "false");
      
      // Iterar sobre cada archivo y agregarlo individualmente
      if (this.files && this.files.length > 0) {
        this.files.forEach((file, index) => {
          formData.append("files[]", file);
        });
      }

      this.isLoading = true;
      axios
        .post(
          `/activity_performances/declare-completed-hours/${this.activityId}.json`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.$emit("close");
          this.$emit("refresh");
          this.$buefy.toast.open({
            message: "Horas declaradas correctamente",
            type: "is-success",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              error.response.data.error ||
              "Hubo un error al guardar los archivos. Por favor, inténtelo nuevamente.",
            type: "is-danger",
            hasIcon: true,
            icon: "alert-circle-outline",
            iconPack: "mdi",
            ariaRole: "alertdialog",
            ariaModal: true,
            onConfirm: () => {},
          });
          this.isLoading = false;
        });
    },
    openModalSaiHours() {
      const filteredSubjectsSemester1 = this.subjectsSemester1.filter(
        (subject) =>
          subject.codigo === parseInt(this.performanceActivity.subject_code)
      );
      const filteredSubjectsSemester2 = this.subjectsSemester2.filter(
        (subject) =>
          subject.codigo === parseInt(this.performanceActivity.subject_code)
      );

      if (
        filteredSubjectsSemester1.length === 0 &&
        filteredSubjectsSemester2.length === 0
      ) {
        this.$buefy.dialog.alert({
          title: "Error",
          message:
            "No registra horas realizadas de esta asignatura en SAI. Ingrese las horas manualmente.",
          type: "is-danger",
          hasIcon: true,
          iconPack: "fa",
          icon: "times-circle",
          confirmText: "Ok",
          onConfirm: () => (this.isActiveModalSaiHours = false),
        });
        return;
      }

      let horasSemestre1 = 0;
      let horasSemestre2 = 0;
      filteredSubjectsSemester1.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre1 += hour_t + hour_e + hour_l;
        this.filteredSubjects.push({
          ...subject,
          total_hours: hour_t + hour_e + hour_l,
          semestre: "1er Semestre",
        });
      });
      filteredSubjectsSemester2.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre2 += hour_t + hour_e + hour_l;
        this.filteredSubjects.push({
          ...subject,
          total_hours: hour_t + hour_e + hour_l,
          semestre: "2do Semestre",
        });
      });
      this.totalHoursSemester1 = horasSemestre1;
      this.totalHoursSemester2 = horasSemestre2;

      this.isActiveModalSaiHours = true;
    },
    completeHoursWithSai() {
      this.performanceActivity.hours_completed_semester_1 =
        this.totalHoursSemester1;
      this.performanceActivity.hours_completed_semester_2 =
        this.totalHoursSemester2;
      
      // IMPORTANTE: Guardar el subject_code para marcar que las horas vienen de SAI
      if (this.asignatura && this.asignatura.codigo) {
        this.performanceActivity.subject_code = this.asignatura.codigo.toString();
      }
      
      this.isActiveModalSaiHours = false;
      this.filteredSubjects = [];
      this.$buefy.toast.open({
        message: "Horas completadas con SAI correctamente",
        type: "is-success",
      });
    },

    // Métodos para manejar evidencias existentes
    getFileIcon(filename) {
      if (!filename) return "file";
      const extension = filename.split(".").pop().toLowerCase();
      if (["doc", "docx"].includes(extension)) return "file-word";
      if (["xls", "xlsx"].includes(extension)) return "file-excel";
      if (extension === "pdf") return "file-pdf";
      if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
        return "file-image";
      return "file";
    },

    getFileIconColor(filename) {
      if (!filename) return "";
      const extension = filename.split(".").pop().toLowerCase();
      if (["doc", "docx"].includes(extension)) return "is-info";
      if (["xls", "xlsx"].includes(extension)) return "is-success";
      if (extension === "pdf") return "is-danger";
      if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
        return "is-warning";
      return "";
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      return new Intl.DateTimeFormat("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(date);
    },

    viewEvidence(evidence) {
      if (evidence.url) {
        window.open(evidence.url, "_blank");
      }
    },

    confirmDeleteEvidence(evidence) {
      this.$buefy.dialog.confirm({
        title: "Eliminar evidencia",
        message: `¿Está seguro de eliminar la evidencia "${evidence.alt_name}"?`,
        confirmText: "Eliminar",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.deleteEvidence(evidence);
        },
      });
    },

    deleteEvidence(evidence) {
      this.isLoading = true;
      axios
        .delete(`/evidences/${evidence.id}.json`)
        .then((response) => {
          // Eliminar de la lista local
          this.existingEvidences = this.existingEvidences.filter(
            (e) => e.id !== evidence.id
          );
          this.$buefy.toast.open({
            message: "Evidencia eliminada correctamente",
            type: "is-success",
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              error.response?.data?.error ||
              "Hubo un error al eliminar la evidencia.",
            type: "is-danger",
            hasIcon: true,
          });
          this.isLoading = false;
        });
    },

    // Intenta cargar automáticamente las horas desde SAI cuando se abre el modal
    attemptAutoFetchFromSAI() {
      // Solo intentar si:
      // 1. Es una asignatura (tiene subject_code)
      // 2. No tiene horas completadas aún (no se ha declarado)
      // 3. No se ha intentado antes en esta sesión del modal
      if (
        this.asignatura &&
        this.asignatura.codigo &&
        this.asignatura.codigo !== -1 &&
        !this.saiAutoFetchAttempted &&
        (!this.performanceActivity.hours_completed_semester_1 || 
         this.performanceActivity.hours_completed_semester_1 === 0) &&
        (!this.performanceActivity.hours_completed_semester_2 || 
         this.performanceActivity.hours_completed_semester_2 === 0)
      ) {
        this.saiAutoFetchAttempted = true;
        this.autoFetchHoursFromSAI();
      }
    },

    // Carga automática de horas desde SAI
    autoFetchHoursFromSAI() {
      const filteredSubjectsSemester1 = this.subjectsSemester1.filter(
        (subject) =>
          subject.codigo === parseInt(this.performanceActivity.subject_code)
      );
      const filteredSubjectsSemester2 = this.subjectsSemester2.filter(
        (subject) =>
          subject.codigo === parseInt(this.performanceActivity.subject_code)
      );

      // Caso: No se encontraron horas en SAI
      if (
        filteredSubjectsSemester1.length === 0 &&
        filteredSubjectsSemester2.length === 0
      ) {
        this.saiAutoFetchSuccess = false;
        this.$buefy.toast.open({
          message: "No se encontraron horas en el sistema SAI automáticamente. Ingréselas manualmente.",
          type: "is-warning",
          duration: 5000,
        });
        return;
      }

      // Caso: Se encontraron horas en SAI
      let horasSemestre1 = 0;
      let horasSemestre2 = 0;

      filteredSubjectsSemester1.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre1 += hour_t + hour_e + hour_l;
      });

      filteredSubjectsSemester2.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre2 += hour_t + hour_e + hour_l;
      });

      // Verificar que realmente se obtuvieron horas
      if (horasSemestre1 === 0 && horasSemestre2 === 0) {
        this.saiAutoFetchSuccess = false;
        this.$buefy.toast.open({
          message: "Las horas obtenidas desde SAI son 0. Verifique o ingrese manualmente.",
          type: "is-warning",
          duration: 5000,
        });
        return;
      }

      // Completar horas automáticamente
      this.performanceActivity.hours_completed_semester_1 = horasSemestre1;
      this.performanceActivity.hours_completed_semester_2 = horasSemestre2;
      this.totalHoursSemester1 = horasSemestre1;
      this.totalHoursSemester2 = horasSemestre2;

      // Guardar el subject_code para marcar que las horas vienen de SAI
      if (this.asignatura && this.asignatura.codigo) {
        this.performanceActivity.subject_code = this.asignatura.codigo.toString();
      }

      this.saiAutoFetchSuccess = true;

      this.$buefy.toast.open({
        message: `Horas obtenidas automáticamente desde el sistema SAI: ${horasSemestre1}h (Sem 1) + ${horasSemestre2}h (Sem 2)`,
        type: "is-success",
        duration: 6000,
      });
    },
  },
};
</script>

<style scoped>
.upload-container-centered {
  display: flex;
  justify-content: center;
  width: 100%;
}

.compact-upload {
  width: auto;
  display: inline-block;
}

.compact-drop-area {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  border: 2px dashed #dbdbdb;
  border-radius: 4px;
  background-color: #fafafa;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.compact-drop-area:hover {
  border-color: #3273dc;
  background-color: #f5f8ff;
}

.compact-drop-area span {
  font-size: 0.95rem;
  color: #4a4a4a;
}
</style>
